var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10X10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 128,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 51,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 153,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 205,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 76,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 178,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 230,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 102,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 128,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 51,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 153,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 205,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 76,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 178,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 230,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 102,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 26,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 128,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 51,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 153,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 205,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 76,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 178,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 230,
    width: 21,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 102,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 26,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 128,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 51,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 153,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 205,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 76,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 178,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 230,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#BDB2FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10X10);
export default __webpack_public_path__ + "static/media/10x10.8acd1b1f7ab01c28337788386c691a21.svg";
export { ForwardRef as ReactComponent };